import React, { useState, useContext, useCallback } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";

import CustomSelect from "shared/components/FormElements/Select";

import { CheckAuthorization } from "shared/util/util";
import { CURRENT_EDUCATION_YEAR_ID } from "shared/util/constants";

import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";

import ContractNew from "./ContractNew";
import ContractList from "./ContractList";
import ContractItem from "./ContractItem";

import "./AccountingItem.css";

import "react-datepicker/dist/react-datepicker.css";
import TabPanel from "shared/components/UIElements/TabPanel";

const Contract = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);
  const [pageItems, setPageItems] = useState(store.contracts.filter((item) => item.year === CURRENT_EDUCATION_YEAR_ID));

  const [educationYear, setEducationYear] = useState(CURRENT_EDUCATION_YEAR_ID);

  const Authorization = CheckAuthorization(auth.userId);

  const yearChangeHandler = (id, value) => {
    setEducationYear(value);
    setPageItems(store.contracts.filter((item) => item.year === value));
  };

  if (Authorization.isSchoolResponsible) {
    setPageItems(
      [...pageItems].filter((item) => item.student.school.toString() === Authorization.currentSchoolId.toString())
    );
  }

  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedItemShow, setSelectedItemShow] = useState(false);

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const ItemSelectHandler = useCallback((itemid) => {
    setSelectedItemShow(true);
    setSelectedItemId(itemid);
  }, []);

  const ItemUpdateHandler = useCallback((itemid) => {
    setSelectedItemId(itemid);
  }, []);

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `contract-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }

  return (
    <React.Fragment>
      <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label="Sözleşmeler" {...a11yProps(0)} />
          <Tab label="Yeni Sözleşme Ekle" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <div style={{ width: "300px" }}>
        <CustomSelect
          options={store.educationYearsOptions}
          id="year"
          onInput={(id, value) => yearChangeHandler(id, value)}
          label=""
          initialValid={true}
          initialValue={store.educationYearsOptions.find((item) => item.value.toString() === educationYear)}
        ></CustomSelect>
      </div>
      <TabPanel value={tabValue} index={0}>
        <div className="adminpageContainer">
          {pageItems && (
            <div className="adminListContainer">
              <ContractList items={pageItems} onItemSelect={ItemSelectHandler} />
            </div>
          )}
          {selectedItemId && selectedItemShow && (
            <div className="adminUpdateContainer">
              <ContractItem
                itemid={selectedItemId}
                onItemUpdate={ItemUpdateHandler}
                onClose={() => setSelectedItemShow(false)}
              ></ContractItem>
            </div>
          )}
        </div>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ContractNew></ContractNew>
      </TabPanel>
    </React.Fragment>
  );
};

export default Contract;
